import workspaceQuery from '../../../graphql/queries/nominal/NominalReportWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/nominal/NominalReportListQuery.graphql';
import instanceQuery from '../../../graphql/queries/nominal/NominalReportQuery.graphql';
import defaultQuery from '../../../graphql/queries/nominal/NominalReportDefault.graphql';
import mutationQuery from '../../../graphql/mutations/nominal/NominalReportMutation.graphql';
import fragment from '../../../graphql/fragments/nominal/NominalReportFragment.graphql';
import { Direction } from '../../schema/p4types';

const NominalReport = {
  type: 'NominalReport',
  title: 'Nominal Report Layout',
  formTitle: 'Nominal Report',
  formUrl: '/Nominal/Report/Details/',
  workspaceUrl: '/Nominal/Report/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    customVariables: () => {
      return {
        orderBy: 'description',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'NOMINAL_REPORT',
};

export default NominalReport;
